import { Array, Intersect, Number, Record, Static, String } from "runtypes";

const Question = Record({
  category: Number,
  text: String,
});

const Response = Record({
  surveyQuestionId: Number,
  surveyResponseId: Number,
});

const ScaleQuestionAndResponse = Record({
  question: Question,
  responses: Array(
    Intersect(
      Response,
      Record({
        response: Number,
      })
    )
  ),
});

export interface IScaleQuestionAndResponse
  extends Static<typeof ScaleQuestionAndResponse> {}

const WrittenResponse = Intersect(
  Response,
  Record({
    response: String,
  })
);

export interface IWrittenResponse extends Static<typeof WrittenResponse> {}

const WrittenQuestionAndResponse = Record({
  question: Question,
  responses: Array(WrittenResponse),
});

export interface IWrittenQuestionAndResponse
  extends Static<typeof WrittenQuestionAndResponse> {}

const SurveyResponse = Record({
  coachId: Number,
  date: String,
  id: Number,
  respondentName: String,
  responseSource: Number,
  surveyId: Number,
});

export interface ISurveyEvaluationResponse
  extends Static<typeof SurveyResponse> {}

export const SurveyEvaluationResponsesRuntype = Record({
  scaleSurveyQuestionResponses: Array(ScaleQuestionAndResponse),
  surveyResponses: Array(SurveyResponse),
  writtenQuestionsResponses: Array(WrittenQuestionAndResponse),
});

export interface ISurveyEvaluationResponses
  extends Static<typeof SurveyEvaluationResponsesRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ISurveyEvaluationResponses.ts